export const DEFAULT_YOUTUBE_METRIC_1 = ['ytFollowersCount'];
export const DEFAULT_YOUTUBE_METRIC_2 = ['ytAvgViews'];
export const DEFAULT_YOUTUBE_METRIC_3 = [
  'ttAvgViewsEngRate',
  'ttAvgEngagements',
];
